/**
 * English Language Profile
 *
 * SVO word order, prepositions, space-separated.
 */

import type { LanguageProfile } from './types';

export const englishProfile: LanguageProfile = {
  code: 'en',
  name: 'English',
  nativeName: 'English',
  regions: ['western', 'priority'],
  direction: 'ltr',
  script: 'latin',
  wordOrder: 'SVO',
  markingStrategy: 'preposition',
  usesSpaces: true,
  // English infinitive and imperative are identical ("toggle", "save", "open")
  defaultVerbForm: 'base',
  verb: {
    position: 'start',
    subjectDrop: false,
  },
  references: {
    me: 'me',
    it: 'it',
    you: 'you',
    result: 'result',
    event: 'event',
    target: 'target',
    body: 'body',
  },
  possessive: {
    marker: "'s",
    markerPosition: 'after-object',
    specialForms: {
      me: 'my',
      it: 'its',
      you: 'your',
    },
    keywords: {
      my: 'me',
      your: 'you',
      its: 'it',
    },
  },
  roleMarkers: {
    destination: { primary: 'on', alternatives: ['to', 'from'], position: 'before' },
    source: { primary: 'from', position: 'before' },
    patient: { primary: '', position: 'before' },
    style: { primary: 'with', alternatives: ['by', 'using'], position: 'before' },
    responseType: { primary: 'as', position: 'before' },
    method: { primary: 'via', alternatives: ['using'], position: 'before' },
  },
  keywords: {
    toggle: { primary: 'toggle' },
    add: { primary: 'add' },
    remove: { primary: 'remove' },
    put: { primary: 'put' },
    append: { primary: 'append' },
    prepend: { primary: 'prepend' },
    take: { primary: 'take' },
    make: { primary: 'make' },
    clone: { primary: 'clone' },
    swap: { primary: 'swap' },
    morph: { primary: 'morph' },
    set: { primary: 'set' },
    get: { primary: 'get' },
    increment: { primary: 'increment' },
    decrement: { primary: 'decrement' },
    log: { primary: 'log' },
    show: { primary: 'show' },
    hide: { primary: 'hide' },
    transition: { primary: 'transition' },
    on: { primary: 'on' },
    trigger: { primary: 'trigger' },
    send: { primary: 'send' },
    focus: { primary: 'focus' },
    blur: { primary: 'blur' },
    go: { primary: 'go' },
    wait: { primary: 'wait' },
    fetch: { primary: 'fetch' },
    settle: { primary: 'settle' },
    if: { primary: 'if' },
    when: { primary: 'when', normalized: 'when' },
    where: { primary: 'where', normalized: 'where' },
    else: { primary: 'else' },
    repeat: { primary: 'repeat' },
    for: { primary: 'for' },
    while: { primary: 'while' },
    continue: { primary: 'continue' },
    halt: { primary: 'halt' },
    throw: { primary: 'throw' },
    call: { primary: 'call' },
    return: { primary: 'return' },
    then: { primary: 'then' },
    and: { primary: 'and' },
    end: { primary: 'end' },
    js: { primary: 'js' },
    async: { primary: 'async' },
    tell: { primary: 'tell' },
    default: { primary: 'default' },
    init: { primary: 'init' },
    behavior: { primary: 'behavior' },
    install: { primary: 'install' },
    measure: { primary: 'measure' },
    beep: { primary: 'beep' },
    break: { primary: 'break' },
    copy: { primary: 'copy' },
    exit: { primary: 'exit' },
    pick: { primary: 'pick' },
    render: { primary: 'render' },
    into: { primary: 'into' },
    before: { primary: 'before' },
    after: { primary: 'after' },
    until: { primary: 'until' },
    event: { primary: 'event' },
    from: { primary: 'from' },
  },
};
